module.exports = __webpack_public_path__ + "static/media/Take the tour my favourite tour.cc68ae7c.mp4";